import { cookie } from 'helpers/cookie'
import { LastAppProps } from './types'
import { AppsRoutes } from '@wellesley/router'

const storePrefix = 'lastAppFor'

const getKey = (id: string = 'global') => `${storePrefix}:${id}`

export const setLastApp = ({
  link,
  username,
  groupname,
}: Pick<LastAppProps, 'link' | 'username' | 'groupname'>) => {
  const key = getKey(groupname || username || 'global')
  cookie.set(key, link, 1 / 24)
}

export const getLastApp = ({
  username,
  groupname,
}: Pick<LastAppProps, 'username' | 'groupname'>) => {
  const key = getKey(groupname || username || 'global')
  return cookie.get(key) as AppsRoutes | undefined
}
